import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRobot, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import CompanyLogo from "../../../common/CompanyLogo";
import ErrorMessage from "../../../common/errormsg/ErrorMessage";
import { LOAN_RANGE, PROPERTY_CHOICE, SIZE_CHOICE } from "../../../utils/Utils";
import { BusinessesLoan } from "../../../api/endpoints";
import toast from "react-hot-toast";
import Api_Instance from "../../../api/Api_Instance";
import CountriesApi from "../../../common/countriesapi/CountriesApi";
function BussinessLoan() {
  // State to store form values
  const api = Api_Instance.useApi();
  const [formValues, setFormValues] = useState({
    loan_range: "",
    name: "",
    email: "",
    phone: "",
    address: "",
    country: "",
    state: "",
    city: "",
    pincode: "",
    propertys: "",
    size: "",
    property_values: "",
    purpose_loan: "",
  });

  const [errors, setErrors] = useState({});
  const [countrydata, setCountrydata] = useState({
    countryid: "",
    stateid: "",
    cityid: "",
  });
  const { useCountries, States, Ctiy } = CountriesApi;
  const { countries } = useCountries();
  const { statedata } = States(countrydata.countryid);
  const { citydata } = Ctiy(countrydata.stateid);

  const handleCountryChange = (event) => {
    const { value, options, selectedIndex } = event.target;
    const selectedCountryName = options[selectedIndex].text;
    setFormValues((prevValues) => ({
      ...prevValues,
      country: value,
      state: "",
      city: "",
    }));
    setCountrydata((prev) => ({
      ...prev,
      countryid: selectedIndex - 1,
    }));
  };
  const initialFormValues = {
    loan_range: "",
    name: "",
    email: "",
    phone: "",
    address: "",
    country: "",
    state: "",
    city: "",
    pincode: "",
    propertys: "",
    size: "",
    property_values: "",
    purpose_loan: "",
  };
  const handleStateChange = (event) => {
    const { value, options, selectedIndex } = event.target;
    const selected_id = options[selectedIndex].getAttribute("data-id");
    setFormValues((prevValues) => ({
      ...prevValues,
      state: value,
      city: "",
    }));
    setCountrydata((prev) => ({
      ...prev,
      stateid: selected_id,
    }));
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };
  const handleBlur = (e) => {
    const { name, value } = e.target;
    const validationErrors = validate({
      ...formValues,
      [name]: value,
    });
    setErrors(validationErrors);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const validationErrors = validate(formValues);
      setErrors(validationErrors);
      if (Object.keys(validationErrors).length === 0) {
        const res = await api(
          "POST",
          BusinessesLoan.POST_BUSSINESS_LOAN,
          formValues
        );
        if (res.data.status) {
          toast.success(res.data.message || "Successfully Create");
          setFormValues(initialFormValues)
        } else {
          toast.error(res.data.message || "invalid data");
        }
      }
    } catch (error) {
      if (error?.response?.data?.code === "token_not_valid") {
        toast.error("Session expired please login again");
      } else if (
        error?.response?.data?.detail ===
        "Authentication credentials were not provided."
      ) {
        toast.error("please login you are not authorized");
      } else {
        toast.error(error.message || "invalid data");
      }
    }
  };
  const pinCodeRegex = /^\d{6}$/;
  const emojiRegex =
    /([\u{1F600}-\u{1F64F}|\u{1F300}-\u{1F5FF}|\u{1F680}-\u{1F6FF}|\u{1F700}-\u{1F77F}|\u{1F780}-\u{1F7FF}|\u{1F800}-\u{1F8FF}|\u{1F900}-\u{1F9FF}|\u{1FA00}-\u{1FA6F}|\u{1FA70}-\u{1FAFF}|\u{2600}-\u{26FF}|\u{2700}-\u{27BF}|\u{2300}-\u{23FF}|\u{2B50}|\u{1F004}-\u{1F251}]+|\u{1F004}-\u{1F251}|\u{1F1E6}-\u{1F1FF})/gu;
  function formatField(field) {
    let formatted = field.replace(/_/g, " ");
    formatted = formatted.charAt(0).toUpperCase() + formatted.slice(1);
    return formatted;
  }
  const propertyValuesRegex = /^\d{0,10}$/;
  const validate = (values) => {
    const errors = {};
    const requiredFields = [
      "loan_range",
      "name",
      "email",
      "phone",
      "address",
      "country",
      "state",
      "city",
      "pincode",
      "propertys",
      "size",
      "property_values",
      "purpose_loan",
    ];

    requiredFields.forEach((field) => {
      const value = values[field];
      if (
        value === undefined ||
        value === null ||
        (typeof value === "string" && !value.trim())
      ) {
        if (field != "state" && field != "city") {
          errors[field] = `${formatField(field)} is required`;
        } else if (field == "state" && statedata.length > 0) {
          errors[field] = `${formatField(field)} is required`;
        } else if (field == "city" && citydata.length > 0) {
          errors[field] = `${formatField(field)} is required`;
        }
      }
    });
    const mobileNumberRegex = /^[6-9]\d{9}$/;
    if (values.phone) {
      if (!mobileNumberRegex.test(values.phone)) {
        errors.phone =
          "Mobile number invalid.";
      }
    } else {
      errors.phone = "Mobile number is required.";
    }
    if (values.name) {
      if (!/^[A-Za-z\s]+$/.test(values.name)) {
      } else if (values.name.length < 2) {
        errors.name = "Name must be at least 2 characters";
      } else if (values.name.length > 20) {
        errors.name = "Name must be at most 20 characters";
      } else if (emojiRegex.test(values.name)) {
        errors.name = "Name should not contain emojis";
      }
    }

    if (values.email && !/\S+@\S+\.\S+/.test(values.email)) {
      errors.email = "Email address is invalid";
    }
    if (values.mobile_number && !/^\d{10}$/.test(values.mobile_number)) {
      errors.mobile_number = "Mobile No is invalid";
    }
    if (values.pincode) {
      if (!pinCodeRegex.test(values.pincode)) {
        errors.pincode =
          "Pincode must be exactly 6 digits and contain no letters, spaces, or special characters.";
      }
      if (emojiRegex.test(values.pincode)) {
        errors.pincode = "Pincode should not contain emojis";
      }
    }
    if (values.property_values && !propertyValuesRegex.test(values.property_values)) {
      errors.property_values = "Property Values can not more then 10 digits and contain no letters, spaces, or special characters.";
    }
    if (values.address) {
      const addressLength = values.address.trim().length;
      if (emojiRegex.test(values.address)) {
        errors.address = "Address should not contain emojis";
      }
     if (addressLength > 150) {
        errors.address = "Address must not exceed 150 characters.";
      }
    } else {
      errors.address = "Address is required.";
    }

    if (values.purpose_loan) {
      const addressLength = values.purpose_loan.trim().length;
      if (emojiRegex.test(values.purpose_loan)) {
        errors.purpose_loan = "Purpose loan should not contain emojis";
      }
      if (addressLength < 20) {
        errors.purpose_loan = "Purpose loan must be at least 20 characters long.";
      }
      else if (addressLength > 250) {
        errors.purpose_loan = "Purpose loan must not exceed 250 characters.";
      }
    } else {
      errors.purpose_loan = "Purpose loan is required.";
    }

    return errors;
  };
  return (
    <div>
      <CompanyLogo title={"Loan For Business"}    subtitle={"Loan For Business"}/>
      <div className="w-full max-w-[1250px]     mx-auto mt-5 xl:px-0 lg:px-0 md:px-5 px-4">
        <h1 className="text-start font-bold text-4xl mb-2 ">
          Loan for <span className="text-primaryColor"> Bussiness</span>
        </h1>
        <hr className="mt-4"/>
      </div>
      <div className="flex xl:flex-row lg:flex-row md:flex-row flex-col items-start justify-between mx-auto mt-3 w-full max-w-[1250px]     mx-auto xl:px-0 lg:px-0 md:px-5 px-4">

        <div className="flex-[0_0_50%]">
          <div className="bg-card_bg_color border p-3 rounded-lg ">

            <div className="mt-2 flex justify-center md:justify-start">
              <p className="flex flex-wrap text-justify md:text-left w-full md:max-w-none">
                Loans against property offer a viable financial solution where
                property owners can leverage their real estate assets to secure
                funds for various needs. At Franchise India Property Loan, we
                understand the significance of unlocking the value of your property.
                Whether it's expanding your business, funding education, managing
                unforeseen expenses, or consolidating debts, our property loan
                services provide a flexible and efficient borrowing option. With
                competitive interest rates, tailored repayment plans, and
                hassle-free processing, we empower individuals to access substantial
                funds while retaining ownership of their valuable property. Our
                expert team assists in navigating the loan process, ensuring
                transparency, and offering guidance at every step. Unlock the
                potential of your property with Franchise India's property loan
                solutions and accomplish your financial goals with confidence.
              </p>
            </div>
          </div>
        </div>
        <div className="flex-[0_0_48%]">
        
            <div className="mx-auto">
              <div className="rounded-lg w-full mt-0">
                <form onSubmit={handleSubmit} className="bg-card_bg_color border p-3 rounded-lg ">
                  <h2 className="text-2xl mb-5 font-bold">
                    Please provide your details to help us serve you better
                  </h2>
                  <div className="w-1/1 grid grid-cols-1 sm:grid-cols-2  gap-4  ">
                    <div className="flex-1 relative">
                      <label htmlFor="loan_range" className="mb-2 font-md block font-semibold capitalize">
                        Select Loan Range <span className="text-star_color">*</span>
                      </label>
                      <select
                        id="loan_range"
                        name="loan_range"
                        value={formValues.loan_range}
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        onBlur={handleBlur}
                        class="border rounded w-full p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      >
                        <option value="" disabled>
                          Select Loan Range
                        </option>
                        {LOAN_RANGE?.map((item) => (
                          <option value={item.value}>{item.label}</option>
                        ))}
                      </select>

                      {errors.loan_range && (
                        <ErrorMessage error={errors.loan_range} />
                      )}
                    </div>
                    <div className="flex-1 ">
                      <label htmlFor="Name" className="mb-2 font-md block font-semibold capitalize">
                        Name <span className="text-star_color">*</span>
                      </label>
                      <input
                        type="text"
                        id="Name"
                        name="name"
                        value={formValues.name}
                        onChange={handleChange}
                        placeholder="Enter Name"
                        className="p-2 h-[38px] border border-gray-300 rounded w-full"
                      />

                      {errors.name && (
                        <p className="text-star_color text-sm">{errors.name}</p>
                      )}
                    </div>
                    <div className="">
                      <label htmlFor="Mobile" className="mb-2 font-md block font-semibold capitalize">
                        Mobile <span className="text-star_color">*</span>
                      </label>
                      <input
                        type="text"
                        id="Mobile"
                        name="phone"
                        value={formValues.phone}
                        onChange={handleChange}
                        placeholder="Enter Mobile"
                        className="p-2 h-[38px] border border-gray-300 rounded w-full"
                      />

                      {errors.phone && (
                        <p className="text-star_color text-sm">{errors.phone}</p>
                      )}
                    </div>
                    <div className="">
                      <label htmlFor="Email" className="mb-2 font-md block font-semibold capitalize">
                        Email <span className="text-star_color">*</span>
                      </label>
                      <input
                        type="text"
                        id="Email"
                        name="email"
                        value={formValues.email}
                        onChange={handleChange}
                        placeholder="Enter Email"
                        className="p-2 h-[38px] border border-gray-300 rounded w-full"
                      />

                      {errors.email && (
                        <p className="text-star_color text-sm">{errors.email}</p>
                      )}
                    </div>
                    <div className="">
                      <label htmlFor="Address" className="mb-2 font-md block font-semibold capitalize">
                        Address<span className="text-star_color">*</span>
                      </label>
                      <input
                        type="text"
                        id="Address"
                        name="address"
                        value={formValues.address}
                        onChange={handleChange}
                        placeholder="Enter Address"
                        className="p-2 h-[38px] border border-gray-300 rounded w-full"
                      />

                      {errors.address && (
                        <p className="text-star_color text-sm">{errors.address}</p>
                      )}
                    </div>

                    <div className="">
                      <label htmlFor="country" className="block text-sm font-semibold mb-2">
                        Country <span className="text-star_color">*</span>
                      </label>
                      <select
                        id="country"
                        name="country"
                        value={formValues.country}
                        onChange={handleCountryChange}
                        onBlur={handleBlur}
                        class="border rounded w-full p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      >
                        <option value="" disabled>
                          Select Country
                        </option>
                        {countries?.map((item) => (
                          <option value={item.name}>{item.name}</option>
                        ))}
                      </select>

                      {errors.country && <ErrorMessage error={errors.country} />}
                    </div>
                    <div className="">
                      <label htmlFor="state" className="block text-sm font-semibold mb-2">
                        State{" "}
                        {statedata.length > 0 && (
                          <span className="text-star_color">*</span>
                        )}
                      </label>
                      <select
                        id="state"
                        name="state"
                        value={formValues.state}
                        onChange={handleStateChange}
                        onBlur={handleBlur}
                        class="border rounded w-full p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      >
                        <option value="" disabled>
                          Select State
                        </option>
                        {statedata?.map((item) => (
                          <option value={item.name} data-id={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>

                      {errors.state && <ErrorMessage error={errors.state} />}
                    </div>
                    <div className="">
                      <label htmlFor="city" className="block text-sm mb-2 font-semibold">
                        City
                        {citydata.length > 0 && (
                          <span className="text-star_color">*</span>
                        )}
                      </label>
                      <select
                        id="city"
                        name="city"
                        value={formValues.city}
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        onBlur={handleBlur}
                        class="border rounded w-full p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      >
                        <option value="" disabled>
                          Select City
                        </option>
                        {citydata?.map((item) => (
                          <option value={item.name}>{item.name}</option>
                        ))}
                      </select>

                      {errors.city && <ErrorMessage error={errors.city} />}
                    </div>
                    <div className="relative">
                      <label htmlFor="Pincode" className="mb-2 font-md block font-semibold capitalize">
                        Pincode<span className="text-star_color">*</span>
                      </label>
                      <input
                        type="text"
                        id="Pincode"
                        name="pincode"
                        value={formValues.pincode}
                        onChange={handleChange}
                        placeholder="Enter Pincode"
                        className="p-2 h-[38px] border border-gray-300 rounded w-full"
                      />
                      {/* <FontAwesomeIcon
                icon={faChevronDown}
                className="absolute right-3 top-12 transform -translate-y-1/2 text-gray-400"
              /> */}
                      {errors.pincode && (
                        <p className="text-star_color text-sm">{errors.pincode}</p>
                      )}
                    </div>

                    <div className="relative">
                      <label htmlFor="propertytype" className="mb-2 font-md block font-semibold capitalize">
                        Type of Property<span className="text-star_color">*</span>
                      </label>
                      <select
                        id="propertytype"
                        name="propertys"
                        value={formValues.propertys}
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        onBlur={handleBlur}
                        class="border rounded w-full p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      >
                        <option value="" disabled>
                          Select Property
                        </option>
                        {PROPERTY_CHOICE?.map((item) => (
                          <option value={item.value}>{item.label}</option>
                        ))}
                      </select>

                      {errors.propertys && <ErrorMessage error={errors.propertys} />}
                    </div>
                    <div className="relative">
                      <label htmlFor="size" className="mb-2 font-md block font-semibold capitalize">
                        Property Size<span className="text-star_color">*</span>
                      </label>
                      <select
                        id="size"
                        name="size"
                        value={formValues.size}
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        onBlur={handleBlur}
                        class="border rounded w-full p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      >
                        <option value="" disabled>
                          Select Property Size
                        </option>
                        {SIZE_CHOICE?.map((item) => (
                          <option value={item.value}>{item.label}</option>
                        ))}
                      </select>

                      {errors.size && <ErrorMessage error={errors.size} />}
                    </div>
                    <div className="">
                      <label htmlFor="property_values" className="mb-2 font-md block font-semibold capitalize">
                        Property Value(INR)<span className="text-star_color">*</span>
                      </label>
                      <input
                        id="property_values"
                        name="property_values"
                        value={formValues.property_values}
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        onBlur={handleBlur}
                        class="border rounded w-full p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      />

                      {errors.property_values && (
                        <ErrorMessage error={errors.property_values} />
                      )}
                    </div>
                  </div>

                  <div class="mt-4">
                    <label
                      for="purpose_loan"
                      className=" py-2 pointer-events-none font-semibold"
                    >
                      Purpose of Loan<span className="text-star_color">*</span>
                    </label>
                    <textarea
                      className="block w-full px-2   py-1 text-base text-gray-700 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="Enter Purpose of Loan"
                      name="purpose_loan"
                      value={formValues.purpose_loan}
                      onChange={handleChange}
                      id="purpose_loan"
                    ></textarea>
                    {errors.purpose_loan && (
                      <p className="text-star_color text-sm">{errors.purpose_loan}</p>
                    )}
                  </div>

                  <div className="flex justify-center items-center ">
                    <button
                      type="submit"
                      className="bg-primaryColor text-white p-2 rounded mt-4 w-56"
                    >
                      Apply Now
                    </button>
                  </div>
                </form>
              </div>
            </div>
       
        </div>
      </div>
    </div>
  );
}

export default BussinessLoan;
